import { Box } from '@material-ui/core';
import React from 'react';
import {
  MAIN_SETTING_PAGE,
  MODULE_MANAGEMENT_PAGE,
  PLAN_PAGE,
  PLAN_PAGE_CANCEL_START,
  SettingsPagePathToSettingsMetaDataMap,
  SETUP_MODULE_PAGE_BASE_PATH,
} from '../../constants';
import { PortalConfigContext, RouteContext } from '../../context';
import { SettingsPageToolbarContext } from '../../context/settingsPageToolbarContext';
import { useCustomerSubscription } from '../../hooks/useCustomerSubscription';
import { usePlanStatus } from '../../hooks/usePlanStatusHook';
import { useAppSelector } from '../../hooks/useStore';
import { BaseDescription } from '../CustomizationForm/BaseDescription';
import BaseTypography from '../Text/BaseTypography';
import { SetupModulePageDescription } from './ModuleManagementPage/SetupModule';
import CurrentPlan from './PlanPage/CurrentPlan';

export const SettingsPageToolbar: React.FC = () => {
  const { pathname } = React.useContext(RouteContext);
  const { name: portalName } = React.useContext(PortalConfigContext);
  const { toolbarActions } = React.useContext(SettingsPageToolbarContext);
  const { isCancelledPlan } = usePlanStatus();
  const { customerSubscription } = useCustomerSubscription();
  const isClient = useAppSelector(state => state.user.isClient);

  const [pageTitle, pageDescription] = React.useMemo(() => {
    let title = SettingsPagePathToSettingsMetaDataMap[pathname]?.label;
    const description =
      isClient && pathname === MAIN_SETTING_PAGE.path
        ? `Manage your general ${portalName} settings` // main settings page description text depends on portal name
        : SettingsPagePathToSettingsMetaDataMap[pathname]?.description;
    if (pathname === MODULE_MANAGEMENT_PAGE.path) {
      // TODO: replace this in the module management page path const
      title = 'Modules';
    }

    return [title, description];
  }, [pathname]);

  // plan settings page description should be calculated based on the current plan
  if (pathname === PLAN_PAGE.path || pathname === PLAN_PAGE_CANCEL_START.path) {
    const label =
      pathname === PLAN_PAGE_CANCEL_START.path
        ? PLAN_PAGE_CANCEL_START.label
        : PLAN_PAGE.label;
    const currentPlanSubscription = isCancelledPlan
      ? undefined
      : customerSubscription;
    return (
      <Box>
        <BaseTypography fontType="24Medium">{label}</BaseTypography>
        <CurrentPlan subscription={currentPlanSubscription} />
      </Box>
    );
  }

  // setup module pages should be calculated based on module id
  if (pathname.includes(SETUP_MODULE_PAGE_BASE_PATH)) {
    return <SetupModulePageDescription />;
  }

  // other settings pages have static title and description
  // that can be defined in the settingsPagePathToSettingsMetaDataMap.
  return (
    <Box
      display="flex"
      width={1}
      justifyContent={toolbarActions ? 'space-between' : 'flex-start'}
      alignItems="center"
    >
      <BaseDescription
        titleFontType="24Medium"
        title={pageTitle}
        descriptions={[pageDescription]}
      />
      {toolbarActions}
    </Box>
  );
};
